module.exports = __webpack_public_path__ + "fonts/KaTeX_Caligraphic-Bold.7489a2f.ttf";